import React from "react";
import { Circle, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import EllipsisTooltip from "@component/tooltip/EllipsisTooltip";
 

export function StatusPipeline({ 
  stages = [], 
  className = "",
  isLoading = false 
}) {
  const pipelineStages = stages.length > 0 ? stages : [];

  return (
    <div className={cn("w-full", className)}>
      <h3 className="text-sm font-semibold text-foreground mb-3">
            Status Pipeline
          </h3>
      <div className="flex flex-wrap items-center gap-2">
        {pipelineStages.map((stage, index) => (
          <div key={stage.id} className="flex items-center">
            <span className="inline-flex items-center">
            <EllipsisTooltip title={stage.tooltip}>
            <div className="group relative inline-flex items-center">
              <div className="px-4 py-2 rounded-full bg-muted/50 border border-border dark:border-card-border dark:hover:border-white hover:border-primary/50 transition-all cursor-pointer min-h-[2.5rem] flex items-center">
                <div className="flex items-center gap-2 w-full">
                  {stage.icon ? (
                    <img src={stage.icon} alt="stage icon" className="h-5 w-5 flex-shrink-0" />
                  ) : (
                    <Circle className="h-5 w-5 text-muted-foreground flex-shrink-0" />
                  )}
                  <div className="flex items-center gap-1 flex-1">
                    <span className="text-xs font-normal text-foreground">{stage.title}</span>
                    {stage.subtitle && (
                      <span className="text-xs text-muted-foreground">·</span>
                    )}
                    {stage.subtitle && (
                      <span 
                        className="text-xs text-muted-foreground"
                      >
                      {stage.subtitle}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            </EllipsisTooltip>
            </span>
            {index < pipelineStages.length - 1 && (
              <ChevronRight className="h-4 w-4 text-muted-foreground mx-1" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default StatusPipeline;
